<template>
  <div>
    <!--Header Components-->
    <base-header class="pb-6" type="">
      <b-row class="align-items-center py-4">
        <b-col lg="2" v-if="$route.params.id != '_new' && 0">
          <b-link href="javascript:void(0)" @click="viewDocumentMilestones" class="float-right" style="color:#2dce89;">
            <i class="fa fa-anchor mr-2"></i>
            {{language_terms['MILESTONES']}}
          </b-link>
        </b-col>
        <b-col lg="2" v-if="$route.params.id != '_new' && 0">
          <b-link href="javascript:void(0)" @click="viewDocumentPrintOuts" class="float-right">
            <i class="fa fa-history mr-2"></i>
            {{language_terms['PRINTOUT_HISTORY']}}
          </b-link>
        </b-col>
      </b-row>
    </base-header>
    <!--Main Container Cards-->
    <b-container fluid class="mt--6 container-padding">
      <b-row>
        <div>
          <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" :is-full-page="true"/>
        </div>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col lg="12">
                    <div>
                      <span style="font-weight: bold">{{ document_title }}</span>
                      &nbsp;
                      <b-link href="javascript:void(0)" @click="viewDocumentMilestones" style="color:#2dce89;">
                        <i v-if="$route.params.id != '_new'" class="fa fa-anchor mr-2"></i>
                      </b-link>                      
                      <span style="color: #ffc107;" v-if="sales_document.status == 'PENDING_APPROVAL'"><i class="far fa-clock fa-lg" ></i></span>
                      <i class="fas fa-check-circle text-green fa-lg" v-if="sales_document.is_approved == 1"></i>
                      &nbsp;
                      <i class="fas fa-print text-blue fa-lg" v-if="sales_document.is_printed == 1"></i>
                      &nbsp;
                      <i class="fas fa-book text-red fa-lg" v-if="sales_document.is_posted == 1"></i>
                    </div>
                    <div>
                      <base-button type="success" @click="newSaleDocument" class="float-right mt--4" v-if="!is_edit">
                          <i class="fa fa-plus"></i>
                          <!-- {{language_terms['NEW']}} -->
                          <!-- {{type == 'SQ' ? language_terms['SALE_QUOTATION'] : ( type == 'SO' ? language_terms['ORDER'] : 
                          (type == 'SI' ? language_terms['INVOICE'] : language_terms['DELIVERY_ORDER']))}} -->
                      </base-button>

                      <el-dropdown v-if="(type != 'SI' && $route.params.id != '_new') && (sales_document.status != 'PENDING_APPROVAL') && !is_view_revision"  class="float-right mr-5">
                        <base-button icon type="warning" class="float-right mt--4">
                          {{language_terms['ACTIONS']}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </base-button>
                        <el-dropdown-menu slot="dropdown">
                          <!-- <el-dropdown-item v-if="type == 'SQ'" @click.native="convertToSO">{{language_terms['CONVERT_TO_SO']}}</el-dropdown-item> -->
                          <el-dropdown-item v-if="type == 'SQ' && sales_document.is_approved != 1" @click.native="convertToSI">{{language_terms['APPROVE']}}</el-dropdown-item>
                          <el-dropdown-item v-if="type == 'SO'" @click.native="convertToSI">{{language_terms['CONVERT_TO_SO']}}</el-dropdown-item>
                          <el-dropdown-item @click.native="copyDocument">{{language_terms['COPY']}}</el-dropdown-item>

                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div>
                      <!-- <base-button  type="primary" class="float-right mr-5" @click="viewRevisions" v-if=" (document_mode != 'approval')">
                          {{language_terms['VIEW_REVISIONS']}}
                      </base-button> -->
                      <b-dropdown :text="language_terms['VIEW_REVISIONS']" class="float-right mr-5" v-if=" (document_mode != 'approval') && 0" variant="primary" >
                        <div v-for="(revision, index) in revisions" :key="index">
                          <b-dropdown-item v-if="revision.is_current == 0" @click="viewRevisionDoc(revision)">
                              <span v-if="revision.revision != 0">{{language_terms['REVISION']}} {{revision.revision}} - {{revision.time_created}}</span>
                              <span v-else>{{language_terms['ORIGINAL']}} - {{revision.time_created}}</span>
                            </b-dropdown-item>
                            <!-- {{revision.is_current}} -->
                            <b-dropdown-divider v-if="revision.is_current == 1" ></b-dropdown-divider>
                            <b-dropdown-item style="background-color:#c3e6cb" active v-if="revision.is_current == 1" @click="viewRevisionDoc(revision)">
                              {{language_terms['CURRENT']}} - {{revision.time_created}} 
                            </b-dropdown-item>
                        </div>
                      </b-dropdown>
                    </div>
                    <div v-if="0">
                      <!-- <base-button icon type="success" class="float-right mr-5" @click="editDocument"  v-if="(is_edit == 0) && (document_mode != 'approval') && (sales_document.action_edit == 1)">
                          <i class="fas fa-edit"></i>
                      </base-button> -->
                      <!-- {{document_mode}} -->

                      <base-button icon type="danger" class="float-right mr-5" @click="rejectDocument" v-if="(sales_document.action_approval == '1') && (document_mode == 'approval')">
                        {{language_terms['REJECT']}}
                      </base-button>
                      <base-button icon type="success" class="float-right mr-5" @click="approveDocument" 
                        v-if="(sales_document.action_approval == '1') && (document_mode == 'approval')">
                        {{language_terms['APPROVE']}}
                      </base-button>
                    </div>

                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col md="5">
                  <label class="form-control-label">{{language_terms["CUSTOMER"]}}</label>
                  <base-input v-model="sales_document.contact_name" v-if="!is_edit" disabled></base-input>
                    <multiselect
                      :internalSearch = "false"
                      v-if="is_edit"
                      v-model="sales_document.customer"
                      id="ajax"
                      label="name"
                      track-by="id"
                      placeholder="Type to search"
                      open-direction="bottom"
                      :options="customers"
                      :multiple="false"
                      :searchable="true"
                      :clear-on-select="false"
                      :close-on-select="true"
                      :options-limit="300"
                      :limit="50"
                      :limit-text="limitText"
                      :max-height="600"
                      :show-no-results="false"
                      :hide-selected="false"
                      :disabled = "sales_document.id != null && !is_edit"
                      @search-change="asyncFindCustomer"
                      @input="onSelectCustomer"
                    >
                    </multiselect>
                </b-col>
                <b-col md="1" class="mt-3">
                  <b-button class="mt-3" :disabled = "sales_document.contact_id == null" variant="success" @click="onClickContactSub"><i class="fa fa-arrow-down"></i>
                  </b-button>
                </b-col>
                <b-col md="2" v-if="type == 'SQ'">
                  <base-input :label="language_terms['RESERVE']">
                    <el-select v-model="sales_document.is_reserved" :disabled="!is_edit" filterable>
                      <el-option
                        v-for="option in yesno"
                        :key="option.value"
                        :label="option.name"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="2">
                  <base-input
                    :label="language_terms['CUSTOMER'] + ' ' + language_terms['REFERENCE']"
                    v-model="sales_document.reference"
                    :disabled="!is_edit"/>
                </b-col>
                <b-col md="2">
                  <base-input
                    :label="language_terms['ATTENTION']"
                    :placeholder="language_terms['ATTENTION']"
                    v-model="sales_document.attention_to"
                    :disabled="!is_edit"
                    />
                </b-col>
                <b-col :md="is_edit ? 2 : 1" v-if="type == 'SI'">
                  <base-input :label="language_terms['INVOICE_TYPE']" :value="sales_document.subtype" disabled/>
                </b-col>
                <!-- <b-col md="1" v-if="(type == 'SI' || type == 'SQ') && !is_edit && auth_user.gp_access == 1">
                  <base-input label="GP (%)" :value="sales_document.gp_percent" disabled/>
                </b-col> -->
              </b-row>
              <b-row>
                <b-col md="3">
                  <base-input :label="language_terms['DATE']" v-if="is_edit">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      @on-change="onChangeDate"
                      style="background-color: white"
                      class="form-control datepicker"
                      v-model="sales_document.date">
                    </flat-picker>
                  </base-input>
                  <base-input
                    :label="language_terms['DATE']"
                    v-model="sales_document.date"
                    v-if="!is_edit"
                    type="date"
                    disabled></base-input>
                </b-col>
                <b-col md="3">
                  <base-input :label="language_terms['SALESPERSON']">
                    <el-select
                      v-model="sales_document.salesperson_contact_id"
                      filterable
                      :placeholder="language_terms['SALESPERSON']"
                      :disabled="(!is_edit)">
                      <!-- :disabled="(!is_edit || sales_document.default_salesperson_contact_id != null)"> -->
                      <el-option
                        v-for="option in salesperson_list"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="3" v-if="0">
                  <base-input :label="language_terms['DELIVERY_DATE']"  v-if="is_edit">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      style="background-color: white"
                      :disabled="!is_edit"
                      class="form-control datepicker"
                      v-model="sales_document.delivery_eta_date"
                    >
                    </flat-picker>
                  </base-input>
                  <base-input
                    :label="language_terms['DELIVERY_DATE']"
                    v-model="sales_document.delivery_eta_date"
                    v-if="!is_edit"
                    type="datetime"
                    disabled>
                  </base-input>
                </b-col>
                <b-col md="3">
                  <base-input :label="language_terms['SETTLEMENT_CURRENCY']">
                    <el-select
                      v-model="sales_document.currency_code"
                      filterable
                      :placeholder="language_terms['SETTLEMENT_CURRENCY']"
                      :disabled="!is_edit">
                      <el-option
                        v-for="option in currencies"
                        :key="option.id"
                        :label="option.code + ' (' + option.prefix + ')'"
                        :value="option.code">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
              </b-row>
              <b-row v-if="is_edit">
                <b-col md="3">
                  <base-input :label="language_terms['OVERDUE_AMOUNT']" :value="(sales_document.customer_amount_overdue * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                </b-col>
                <b-col md="3">
                  <base-input :label="language_terms['AVAILABLE_CREDIT_LIMIT']" :value="(sales_document.customer_credit_limit_available * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                </b-col>
                <b-col md="3">
                  <base-input :label="language_terms['CREDIT_LIMIT']" :value="(sales_document.customer_credit_limit * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                </b-col>
                <b-col md="2">
                  <base-input :label="language_terms['CREDIT_TERMS']" v-model="sales_document.customer_credit_term" disabled></base-input>
                </b-col>
                <b-col md="1">
                  <base-input :label="language_terms['TAX_CODE']" v-model="sales_document.tax_code" disabled></base-input>
                </b-col>
                <!-- <b-col md="2" v-if="$route.params.id != '_new'">
                  <base-input :label="language_terms['STATUS']" :value="language_terms[sales_document.status]" disabled></base-input>
                </b-col> -->
              </b-row>
              <b-row>
                <b-col md="6">
                  <!-- <base-input :label="language_terms['REMARKS']"> -->
                  <base-input label="Remarks (Customer to See)">
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      v-model="sales_document.remarks"
                      :disabled="!is_edit">
                    </textarea>
                  </base-input>
                </b-col>
                <b-col md="6">
                  <!-- <base-input :label="language_terms['INTERNAL_REMARKS']"> -->
                  <base-input label="Remarks (Within Company)">
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      :disabled="!is_edit"
                      v-model="sales_document.remarks_internal"
                    ></textarea>
                  </base-input>
                </b-col>
              </b-row>
              <b-row v-if="type == 'SQ'">
                <b-col md="3">
                  <base-input :label="language_terms['VALIDITY']" v-model="sales_document.i1" type="number" min="0" :disabled="!is_edit" @change="onChangeField(item, index)"></base-input>
                </b-col>
                <b-col md="3">
                  <base-input :label="language_terms['TERMS_OF_PAYMENT']" v-model="sales_document.i2" type="number" min="0" :disabled="!is_edit" @change="onChangeField(item, index)"></base-input>
                </b-col>
                <b-col md="6">
                  <base-input
                    :label="language_terms['DELIVERY'] + ' ' + language_terms['REMARKS']"
                    v-model="sales_document.s1"
                    :disabled="!is_edit"/>
                </b-col>
              </b-row>
            </card>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="sales_document.contact_id">
        <b-col cols="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>{{language_terms["SALES_ITEMS"] }}</h3>
                  </b-col>
                  <b-col cols="4">
                      <base-button icon type="primary" class="float-right" @click="viewOrderHistory" v-if="is_edit">
                        <span class="btn-inner--text">{{language_terms['VIEW_ORDER_HISTORY']}}</span>
                      </base-button>
                  </b-col>
                </b-row>
              </div>
              <!--IF it is the edit mode-->
              <b-row  v-if="is_edit">
                <b-col md="12" v-for="(item, index) in sales_document.items" :key="index">
                  <b-card>
                    <b-row>
                      <b-col md="5">
                        <label class="form-control-label">{{item.sno}}</label>
                        <productLookup v-bind:url="apiProductLookup" v-on:selected="onSelectProduct($event, index)" :lookupId="item.product_code"/>
                      </b-col>
                      <b-col md="1" class="mb-3">
                        <base-input :label="language_terms['QTY']" v-model="item.qty" type="number" min="1" :disabled="!is_edit" @change="onChangeField(item, index)"></base-input>
                      </b-col>
                      <b-col md="1" class="mb-3" >
                        <base-input :label="language_terms['UOM']">
                            <el-select v-model="item.uom" filterable @change="onChangeField(item, index)">
                                <el-option v-for="option in item.uom_list"
                                        :key="option.code"
                                        :label="option.code"
                                        :value="option.code">
                                </el-option>
                            </el-select>
                        </base-input>
                      </b-col>
                      <b-col md="2" class="mb-3">
                        <!-- <base-input :label="language_terms['UNIT_PRICE']" :placeholder="item.unit_price_placeholder" v-model="item.unit_price" type="number" min="0" :disabled="!is_edit" @change="onChangeField(item, index)" v-on:keyup.enter="addSaleItems()"></base-input> -->
                        <base-input :label="language_terms['UNIT_PRICE']" :placeholder="item.unit_price_placeholder" v-model="item.unit_price" type="number" min="0" :disabled="!is_edit" @change="onChangeField(item, index)"/>
                      </b-col>
                      <!-- <b-col lg="1" class="mb-3">
                        <base-input :label="language_terms['SNO']" v-model="item.sno" type="number" min="1" :disabled="!is_edit"/>
                      </b-col> -->
                      <b-col md="1" class="mt-4">
                        <b-form-checkbox class="mt-3" v-model="item.is_group_item" value="1" unchecked-value="0" :disabled="!is_edit" @change.native ="onClickGroupItem(index)">
                          Grouped
                        </b-form-checkbox>
                      </b-col>
                      <b-col md="2" class="mb-3" v-if="item.reservation_max_days">
                        <base-input :label="language_terms['RESERVATION_DAYS']" :placeholder="item.reservation_max_days" v-model="item.reservation_days" type="number" min="0" :disabled="!is_edit" @change="validateReservationDays(item, index)"></base-input>
                      </b-col>
                      <b-col md="2" class="mt-4 float-right">
                        <base-button @click="handleDelete(index, item)" :disabled="sales_document.items.length == 1" size="sm" icon type="danger" class="mt-3"><i class="fas fa-trash-alt"></i ></base-button>
                        <base-button @click="handleInsertBefore(index, item)" :disabled="sales_document.items.length == 1" size="sm" icon type="success" class="mt-3"><i class="fas fa-sun"></i ></base-button>
                        <base-button @click="onClickMoveUp(index, item)" :disabled="sales_document.items.length == 1" size="sm" icon type="success" class="mt-3"><i class="fas fa-arrow-up"></i ></base-button>
                        <base-button @click="onClickMoveDown(index, item)" :disabled="sales_document.items.length == 1" size="sm" icon type="success" class="mt-3"><i class="fas fa-arrow-down"></i ></base-button>
                        <!-- <base-button @click="handleCollapse(index, item)" size="sm" icon type="success" class="mt-3"><i class="fa fa-angle-down"></i></base-button> -->
                      </b-col>
                      <b-col md="12" v-if="item.is_trade == '1'">
                          <label class="form-control-label">{{language_terms["PRODUCT_NAME"]}}</label>
                          <multiselect
                                v-model="item.trade_item"
                                label="product_name"
                                track-by="product_name"
                                placeholder="Type to search"
                                open-direction="bottom"
                                :options="tradeitem_desp_list"
                                :multiple="false"
                                :searchable="true"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :options-limit="300"
                                :limit="50"
                                :limit-text="limitText"
                                :max-height="600"
                                :show-no-results="false"
                                :preserve-search="true"
                                :hide-selected="true"
                                @search-change="asyncFindTradeItemDesp($event, index)"
                                :internalSearch = "false"
                                :taggable="true"
                                @tag="addTag($event, index)"
                                @select="onSelectTradeItemDesp($event, index)"
                              >
                          </multiselect>
                      </b-col>
                      <b-col lg="8" v-if="item.is_trade == '1'" class="mt-4">
                        <label class="form-control-label">{{language_terms["VENDOR"]}}</label>
                        <base-input v-model="item.vendor_name" v-if="!is_edit" disabled></base-input>
                          <multiselect
                            :internalSearch = "false"
                            v-if="is_edit"
                            v-model="item.vendor"
                            id="ajax"
                            label="name"
                            track-by="id"
                            placeholder="Type to search"
                            open-direction="bottom"
                            :options="customers"
                            :multiple="false"
                            :searchable="true"
                            :clear-on-select="false"
                            :close-on-select="true"
                            :options-limit="300"
                            :limit="50"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="false"
                            :hide-selected="false"
                            @search-change="asyncFindVendor"
                            @input="onSelectVendor($event, index)"
                          >
                          </multiselect>
                      </b-col>   
                      <b-col lg="4" v-if="item.is_trade == '1'" class="mt-4">
                          <label class="form-control-label">{{language_terms["UNIT_PRICE"]}}</label>
                          <base-input v-model="item.vendor_unit_price" :disabled="!is_edit"></base-input>
                      </b-col>
                                                               
                      <b-col lg="12" v-if="(item.bom_components.length > 0) && (item.is_bom_configurable == '1')">
                        <hr/>
                        <div class="mb-3">
                            <div style="font-weight:bold;">{{language_terms['BOM_COMPONENTS']}}
                              <!-- <base-button  size="sm" class="mb-2 ml-3" icon type="primary" @click.native="addBomComponent(index)">
                                <i class="fa fa-plus"></i >
                              </base-button> -->
                            </div>
                        </div>
                        <b-card v-for="(component, j) in item.bom_components" :key="j">
                          <b-row>
                              <b-col cols="10">
                                    <h5 class="mb-0"><span class="text-primary">{{component.group_name}}</span> </h5>
                              </b-col>
                              <b-col cols="2">
                                  <base-button @click="handleCollapseBomGroup(index, j, component)" size="sm" icon type="success" class="float-right mr-1"><i class="fa fa-angle-down"></i></base-button>
                                  <!-- <base-button @click="deleteBomGroup(index, j)" size="sm" icon type="danger" class="float-right mr-4"><i class="fas fa-trash-alt" ></i ></base-button> -->
                              </b-col>
                              <b-col cols="12">
                                <b-collapse v-model="component.is_collapsed_bom_item" class="mt-2">
                                    <div>
                                    <b-table :items="component.boms" :fields="bomTabelFields" head-variant="light"  v-if="component.boms.length > 0">
                                        <template #cell(index)="data">
                                            {{data.index + 1}}
                                        </template>
                                        <template #cell(is_included)="row">
                                          <!-- {{row}} -->
                                            <b-form-checkbox class="mb-3" v-model="row.item.is_included" value="1" unchecked-value="0" :disabled="!is_edit" @change="setBomItemInclude(row.index, j, index, row.item)"></b-form-checkbox>
                                        </template>
                                        <!-- <template #cell(deleteBtn)="row">
                                            <base-button icon type="warning" @click="removeBomItemFromGroup(row.index, j, index)" size="sm">
                                                <i class="fa fa-trash"></i>
                                            </base-button>
                                            <base-button icon type="success" @click="setBomItemInclude(row.index, j, index, row.item)" size="sm" v-if="row.item.is_included == '0'">
                                                {{language_terms['SELECT']}}
                                            </base-button>
                                        </template> -->
                                    </b-table>
                                    </div>
                                </b-collapse>
                              </b-col>
                          </b-row>
                        </b-card>

                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="2" class="mb-3">
                        <base-input :label="language_terms['AVAILABLE_QTY']" :value="item.qty_available" disabled></base-input>
                      </b-col>
                      <b-col lg="2" class="mb-3">
                        <base-input :label="language_terms['RESERVED_QTY']" :value="item.qty_reserved" @click.native="showReservations(item)" disabled></base-input>
                      </b-col>
                      <b-col lg="1" class="mb-3">
                        <base-input :label="language_terms['GIT_QTY']" :value="item.qty_git" @click.native="showGITSchedules(item)" disabled></base-input>
                      </b-col>
                      <b-col lg="1">
                        <base-input :label="language_terms['MOQ']" :value="item.moq_display" type="text" disabled></base-input>
                      </b-col>
                      <b-col lg="2">
                        <base-input :label="language_terms['LIST_PRICE']" :value="item.sale_list_price_display" type="text" disabled></base-input>
                      </b-col>
                      <b-col lg="1">
                        <base-input :label="language_terms['DISCOUNT'] + ' %'" :value="isNaN((item.unit_discount / item.sale_list_price_display)) ? '-' : (item.unit_discount / item.sale_list_price_display) * 100" disabled></base-input>
                      </b-col>
                      <b-col lg="1">
                        <base-input :label="language_terms['UNIT_DISCOUNT']" :value="isNaN(item.unit_discount) ? '-' : (item.unit_discount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                      </b-col>
                      <b-col lg="2">
                          <base-input :label="language_terms['AMOUNT']" :value="item.gross_amount" type="number" min="0" disabled></base-input>
                      </b-col>
                    </b-row>                        

                    <!-- <b-collapse v-model="item.is_collapsed" visible> -->
                    <b-collapse visible>                    
                        <b-row class="mb-3">
                          <b-col lg="11"  v-if="item.is_trade == '0'">
                            <base-input :placeholder="item.name" v-model="item.product_name" type="text" :disabled="!is_edit" :label="language_terms['PRODUCT_DESP']"></base-input>
                          </b-col>
                         <b-col lg="1" class="mt-4">
                            <b-form-checkbox class="mt-3" v-model="item.has_memo" value="1" unchecked-value="0" :disabled="!is_edit" @change="toggleMemo(item.has_memo, index)">
                                {{language_terms['MEMO']}}
                            </b-form-checkbox>
                          </b-col>
                          <b-col lg="12" v-if="item.has_memo == 1">
                              <base-input >
                                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="item.product_remarks" :disabled="!is_edit"></textarea>
                              </base-input>
                          </b-col>
                        </b-row>

                        <b-row v-if="item.history != null && item.history.length > 0 && item.has_memo == 1">
                          <b-col cols="12">
                            <h4>{{language_terms["PRICE_HISTORY"] }}</h4>
                          </b-col>
                          <b-col cols="12">
                            <v-client-table v-model="item.history" :columns="priceHistoryColumns" :options="priceHistoryOptions" >
                            </v-client-table>
                          </b-col>
                        </b-row>
                    </b-collapse>
                  </b-card>
                </b-col>
              </b-row>
              <!--IF it is the retrieve mode-->
              <b-row v-else>
                  <b-col sm="12">
                      <b-table-simple striped hover responsive>
                          <b-thead head-variant="light">
                            <tr>  
                                <th>{{language_terms['SNO']}}</th>
                                <th>{{language_terms['PRODUCT_CODE']}}</th>
                                <th>{{language_terms['PRODUCT']}}</th>
                                <th>{{language_terms['QTY']}}</th>
                                <th>{{language_terms['UOM']}}</th>
                                <th>{{language_terms['LIST_PRICE']}}</th>
                                <th>{{language_terms['UNIT_PRICE']}}</th>
                                <th>{{language_terms['AMOUNT']}}</th>
                                <th v-if="(type == 'SI' || type == 'SQ') && auth_user.gp_access == 1">Total Cost</th>
                                <th v-if="(type == 'SI' || type == 'SQ') && auth_user.gp_access == 1">GP (%)</th>
                                <!-- <th>{{language_terms['TAX_AMOUNT']}}</th> -->
                                <!-- <th>{{language_terms['NETT_AMOUNT']}}</th> -->
                            </tr>
                          </b-thead>
                          <b-tbody>
                              <b-tr v-for="(row, index) in sales_document.items" :key="index">
                                 <td width="20px">{{ row.sno }}</td>
                                <td>{{row.product_code}}</td>
                                 <td>{{(row.product_name == null || row.product_name == "") ? row.product_name_master : row.product_name}}</td>
                                 <td>{{row.qty}}</td>
                                 <td>{{row.uom}}</td>
                                 <td>{{(row.sale_list_price * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                 <td>{{(row.unit_price * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                 <td>{{(row.gross_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                 <td @click = "onClickSetCost(row)" v-if="(type == 'SI' || type == 'SQ') && auth_user.gp_access == 1">{{(row.total_cost_home * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                 <td v-if="(type == 'SI' || type == 'SQ') && auth_user.gp_access == 1">{{(row.gp_percent * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                 <!-- <td>{{row.tax_amount}}</td> -->
                                 <!-- <td>{{row.nett_amount}}</td> -->
                              </b-tr>
                          </b-tbody>
                      </b-table-simple>
                  </b-col>
              </b-row>
              <!-- Summary Start -->
              <b-row v-if="!is_edit">
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['SUB_TOTAL']}}</label>
                    <b-col md="7">
                      <base-input :value="(sales_document.gross_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row v-else>
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['SUB_TOTAL']}}</label>
                    <b-col md="7">
                      <base-input :value="(gross_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row  style="margin-top:-38px" v-if="!is_edit">
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['DISCOUNT_AMOUNT_OR_PERCENTAGE']}}</label>
                    <b-col md="7">
                      <!-- <base-input :value="(sales_document.discount_value * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input> -->
                      <base-input :value="sales_document.discount_value" disabled></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row  style="margin-top:-38px" v-else>
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['DISCOUNT_AMOUNT_OR_PERCENTAGE']}}</label>
                    <b-col md="7">
                      <base-input v-model="sales_document.discount_value" @change="calDocumentTotal()"></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row  style="margin-top:-38px" v-if="!is_edit">
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['DISCOUNT_AMOUNT']}}</label>
                    <b-col md="7">
                      <base-input :value="(sales_document.discount_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row  style="margin-top:-38px" v-else>
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['DISCOUNT_AMOUNT']}}</label>
                    <b-col md="7">
                      <base-input :value="(discount_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row  style="margin-top:-38px" v-if="!is_edit"> 
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['TAX_AMOUNT']}} 
                      <!-- <span>({{this.sales_document.tax_rate_percent}}%)</span> -->
                    </label>
                    <b-col md="7">
                      <base-input :value="(sales_document.tax_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row  style="margin-top:-38px" v-else> 
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['TAX_AMOUNT']}} 
                      <span>({{this.sales_document.tax_rate_percent}}%)</span>
                    </label>
                    <b-col md="7">
                      <base-input :value="(tax_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row  style="margin-top:-38px" v-if="!is_edit">
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['GRAND_TOTAL']}}</label>
                    <b-col md="7">
                      <base-input :value="(sales_document.nett_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row  style="margin-top:-38px" v-else>
                <b-col lg="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">{{language_terms['GRAND_TOTAL']}}</label>
                    <b-col md="7">
                      <base-input :value="(nett_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row style="margin-top:-38px" v-if="(type == 'SI' || type == 'SQ') && !is_edit && auth_user.gp_access == 1">
                <b-col md="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">GP (%)</label>
                    <b-col md="7">
                      <base-input :value="sales_document.gp_percent" disabled/>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row style="margin-top:-38px" v-if="(type == 'SI' || type == 'SQ') && !is_edit && auth_user.gp_access == 1">
                <b-col md="9"></b-col>
                <b-col md="3">
                  <b-row class="form-group">
                    <label class="col-md-5 col-form-label form-control-label">Total Cost (S$)</label>
                    <b-col md="7">
                      <base-input :value="(sales_document.total_cost_amount_home * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled/>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <!-- Summary End -->
            </card>
          </div>
        </b-col>
      </b-row>
      <!-- {{sales_document.revision_json}} -->
      <b-row v-if="sales_document.revision_json && $route.params.id != '_new'">
        <b-col cols="12">
          <div class="card-wrapper" v-if="0">
            <card>
              <div slot="header" class="mb-0">
                <h3>{{ language_terms["SUMMARY_OF_CHANGES"] }}</h3>
              </div>
              <b-row>
                <b-col cols="12">
                    <b-table-simple hover responsive striped>
                      <b-thead head-variant="light">
                         <b-th>{{language_terms['CHANGE_IN']}}</b-th>
                         <b-th>{{language_terms['OLD_VALUE']}}</b-th>
                         <b-th>{{language_terms['NEW_VALUE']}}</b-th>
                         <b-th>{{language_terms['REMARKS']}}</b-th>
                      </b-thead>
                      <b-tbody>
                         <tr v-for="(value, name) in sales_document.revision_json" :key="name" >
                           <td>{{name}}</td>
                           <td v-if="name != 'items'">
                              {{value.old}}
                           </td>
                           <td v-else>
                              -
                          </td>
                          <td v-if="name != 'items'">
                              {{value.new}}
                           </td>
                           <td v-else>
                              -
                           </td>
                           <td> {{value.remarks ? value.remarks : '-'}}</td>
                         </tr>
                      </b-tbody>
                    </b-table-simple>
                </b-col>
              </b-row>
            </card>
          </div>

        </b-col>
      </b-row>
      <!-- <b-row>
          <a href="javascript:void(0)" class="float-button2 mr-9" @click="addSaleItems" v-if="((sales_document.contact_id != null && sales_document.contact_id != '') && is_edit)" >
            <i class="fas fa-plus my-float-button"></i>
          </a>
      </b-row> -->
    </b-container>

    <b-modal v-model="modalAlternativeContactInfo" :header-bg-variant="'success'" centered hide-footer>
      <template >
        <b-row class="align-items-center mt--2">
          <b-col md="12" fluid class="mt--7">
              <h3 style="color: white;">Additional Contact Info</h3>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col lg="12">
          <base-input
              :label="language_terms['NAME']"
              v-model="sales_document.alt_contact_name"
              :disabled="!is_edit"
          ></base-input>
        </b-col>
        <b-col lg="12">
          <base-input :label="language_terms['ADDRESS']">
            <textarea
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="5"
              v-model="sales_document.alt_contact_address"
              :disabled="!is_edit">
            </textarea>
            </base-input>
        </b-col>
      </b-row>
    </b-modal>

    <!--Show Printouts MODAL-->
    <b-modal v-model="printouts_modal" :header-bg-variant="'primary'"  centered class="my-modal" hide-footer>
      <template #modal-title>
          <span style="color: white">{{language_terms['PRINTOUT_HISTORY']}}</span>
      </template>
      <b-row>
        <b-col sm="12" v-if="printouts.length > 0">
          <b-table-simple hover striped responsive>
            <b-thead head-variant="light">
                <b-th>{{language_terms['SNO']}}</b-th>
                <b-th>{{language_terms['FILE']}}</b-th>
                <b-th>{{language_terms['TIME_CREATED']}}</b-th>
            </b-thead>
            <b-tbody>
                <tr v-for="(data, index) in printouts" :key="index">
                  <td>{{index + 1}}</td>
                  <td>
                      <a :href="data.url" target="_blank"><i class="fa fa-file" aria-hidden="true"></i> &nbsp; {{data.file_alias}}</a>
                  </td>
                  <td>{{data.time_printed}}</td>
                </tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
        <b-col sm="12" v-else>
            <div align="center">{{language_terms['NO_DATA_AVAILABLE']}}</div>
        </b-col>
      </b-row>
    </b-modal>

    <!--Reservations Modal-->
    <b-modal v-model="modalReservations" header-bg-variant="dark"  centered class="my-modal" size="xl" hide-footer>
      <template >
        <b-row class="align-items-center mt--2">
          <b-col md="12" fluid class="mt--7">
              <h3 style="color: white;">{{language_terms['RESERVATIONS']}}</h3>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col cols="12">
            <div class="table-responsive">
              <b-table
                  :items="reservations.items"
                  :fields="reservations.columns"
                  :current-page="currentPage"
                  per-page="100"
                  show-empty
                  >
              </b-table>
            </div>
        </b-col>
      </b-row>
    </b-modal>

    <!--GIT Modal-->
    <b-modal v-model="modalGITSchedules" header-bg-variant="dark"  centered class="my-modal" size="xl" hide-footer>
      <template >
        <b-row class="align-items-center mt--2">
          <b-col md="12" fluid class="mt--7">
              <h3 style="color: white;">{{language_terms['GIT_SCHEDULES']}}</h3>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col cols="12">
            <div class="table-responsive">
              <b-table
                  :items="git_schedules.items"
                  :fields="git_schedules.columns"
                  :current-page="currentPage"
                  per-page="100"
                  show-empty
                  >
              </b-table>
            </div>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Show Order History Modal -->
    <b-modal v-model="sales_items_history_modal" header-bg-variant="dark"  centered class="my-modal" size="xl" hide-footer>
      <template >
        <b-row class="align-items-center mt--2">
          <b-col md="12" fluid class="mt--7">
              <h3 style="color: white;">{{language_terms['ITEMS_HISTORY']}}</h3>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col lg="11" md="10" sm="8" class="mb-3">
          <b-form-input v-model="filter" type="search" placeholder="Search"></b-form-input>&nbsp;
        </b-col>
        <b-col lg="1" md="2" sm="4">
          <b-button variant="success" @click="addToItems()">
            <i class="fa fa-plus"></i>
          </b-button>
        </b-col>
        <b-col cols="12">
            <div class="table-responsive">
              <b-pagination
                v-model="currentPage"
                :total-rows="items_history.length"
                per-page="5"
                aria-controls="my-table"
              ></b-pagination>
                <b-table
                    :items="items_history"
                    :fields="items_history_fields"
                    :current-page="currentPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    per-page="5"
                    show-empty
                    @filtered="onFiltered">
                    <template #cell(product_code)="row">
                      {{row.item.product_code}}<br/>{{row.item.product_name}}<br/>{{row.item.product_remarks}}
                    </template>
                    <template #cell(unit_price)="row">
                      {{(row.item.unit_price * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}
                    </template>
                    <template #cell(is_selected)="row">
                      <b-form-checkbox v-model="row.item.is_selected" value="1" unchecked-value="0"></b-form-checkbox>
                    </template>
                </b-table>
            </div>

        </b-col>
      </b-row>
    </b-modal>
    <!-- Show Milestone Modal-->
      <b-modal v-model="milestones_modal" :header-bg-variant="'success'"  centered class="my-modal" hide-footer size="xl">
        <template #modal-title>
            <span style="color: white;vertical-align: text-bottom;">{{language_terms['MILESTONES']}}</span>
        </template>
        <b-row>
          <b-col cols="12" v-if="milestones.length > 0">
            <ul class="timeline">
              <li v-for="(milestone, index) in milestones" :key="index" :class="getMilestoneClass(milestone)">
                <a href="javascript:void(0)" :style="getMilestoneTxtStyle(milestone)">{{language_terms[milestone.status]}}</a>
                <span class="float-right" style="font-size:small">{{milestone.time_created}}</span>
                <p style="font-size:small">{{milestone.user_name}}</p>
              </li>
            </ul>
          </b-col>
          <b-col sm="12" v-else>
              <div align="center">{{language_terms['NO_DATA_AVAILABLE']}}</div>
          </b-col>
        </b-row>
          
      </b-modal>
    <!-- Show Revisions Modal-->
     <b-modal v-model="revison_modal" :header-bg-variant="'primary'"  centered class="my-modal" hide-footer size="xl">
        <template #modal-title>
            <span style="color: white">{{language_terms['REVISIONS']}}</span>
        </template>
        <b-row>
          <b-col cols="12" v-if="revisions.length > 0">
            <!-- {{revisions.length}} -->
            <b-table-simple hover striped responsive>
                <b-thead head-variant="light">
                  <b-tr>
                    <b-th>{{language_terms['DOCUMENT_NUMBER']}}</b-th>
                    <b-th>{{language_terms['REVISION']}}</b-th>
                    <b-th>{{language_terms['TIME_REVISED']}}</b-th>
                    <b-th>{{language_terms['USER']}}</b-th>
                    <b-th></b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <tr v-for="(revision, index) in revisions" :key="index" :style="(revision.is_current == 1) ? ('background-color:#c3e6cb') : ('background-color:transparent')">
                    <td> {{revision.document_number}} <span v-if="revision.revision">({{revision.revision}})</span></td>
                    <td> {{revision.revision}}</td>
                    <td> {{revision.time_created}}</td>
                    <td> {{revision.user_name}}</td>
                    <td> <a href="javascript:void(0)" @click = "viewRevisionDoc(revision)"> {{language_terms['VIEW']}}</a> </td>
                  </tr>
                </b-tbody>
            </b-table-simple>
          </b-col>
          <b-col sm="12" v-else>
              <div align="center">{{language_terms['NO_DATA_AVAILABLE']}}</div>
          </b-col>
        </b-row>
     </b-modal>

    <!--Add BOM MODAL-->
    <b-modal v-model="add_bom_modal" :header-bg-variant="'primary'"  size="lg" centered class="my-modal">
        <template #modal-title>
            <span style="color: white">{{language_terms['ADD_BOM_COMPONENT']}}</span>
        </template>
        <b-row>
          <b-col sm="12">
            <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
            <productLookup v-bind:url="apiProductLookup" v-on:selected="selectBomProduct($event)" :lookupId="bom_modal.product_code"/>
          </b-col>
          <b-col sm="12">
              <base-input v-model="bom_modal.qty" type="number" :label="language_terms['QTY']"></base-input>
          </b-col>
          <b-col sm="12">
            <base-input :label="language_terms['UOM']" >
                <el-select v-model="bom_modal.uom" filterable>
                    <el-option v-for="option in uom_list"
                            :key="option.code"
                            :label="option.code"
                            :value="option.code">
                    </el-option>
                </el-select>
            </base-input>
          </b-col>
        </b-row>
        <template #modal-footer="{ ok, cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button variant="primary" @click="addBomSave()">
            {{language_terms['ADD']}}
          </b-button>
          <b-button variant="danger" @click="cancelBomSave()">
            {{language_terms['CANCEL']}}
          </b-button>
      </template>
    </b-modal>
    <!-- <div class="floating-bar" v-if="!is_edit && ((sales_document.is_approved == null || (sales_document.is_approved  == 1 && sales_document.is_printed == 0)) || (sales_document.is_approved == 1 && sales_document.is_printed == 0) || (type == 'SQ'))"> -->
    <div class="floating-bar" v-if="!is_edit && ((sales_document.is_approved == null || (sales_document.is_approved  == 1)) || (sales_document.is_approved == 1 && sales_document.is_printed == 0) || (type == 'SQ'))">      
      <div class="floating-bar-container" align="center">
          <b-button-group >
            <b-button class="transparent-btn" @click="editDocument"  
            v-if="sales_document.is_approved == null || (sales_document.is_approved == 1 && sales_document.is_printed == 0 && sales_document.type == 'SI') || (sales_document.is_approved == 0 && sales_document.type == 'SQ')">
              <i class="fas fa-edit mr-2 text-primary"></i>
              {{language_terms['EDIT']}}
            </b-button>
            <b-button class="transparent-btn" @click="printDocument(0)"  v-if="(sales_document.is_approved == 1 && sales_document.type == 'SI') || sales_document.type == 'SQ' || type == 'SQ'">
              <i class="fas fa-print mr-2 text-info"></i>{{language_terms['PRINT']}}
            </b-button>
            <b-button class="transparent-btn" @click="printDocument(1)" v-if="type == 'SI'">
              <i class="fas fa-print mr-2 text-info"></i>Print Draft
            </b-button>
            <b-button class="transparent-btn" @click="printGP()" v-if="type == 'SI' && auth_user.gp_access == 1">
              <i class="fas fa-dollar-sign mr-2 text-info"></i>Print GP
            </b-button>
          </b-button-group>
      </div>
    </div>
    <div class="floating-bar" v-else-if="is_edit & sales_document.contact_id != null">
      <div class="floating-bar-container" align="center">
          <b-button-group >
            <!-- <b-button class="transparent-btn" @click="addSaleItems" v-if="((sales_document.contact_id != null && sales_document.contact_id != '') && is_edit)">
              <i class="fas fa-plus mr-2 text-warning"></i>{{language_terms['ADD']}}
            </b-button> -->

            <b-button class="transparent-btn" @click="addSaleItems">
              <i class="fas fa-plus mr-2 text-warning"></i>{{language_terms['ADD']}}
            </b-button>

            <b-button class="transparent-btn" @click="onClickSave" v-if="loadingCounter == 0">
              <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}} 
            </b-button>
            <b-button class="transparent-btn" @click="cancelDocument">
              <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CLOSE']}}
            </b-button>
          </b-button-group>
      </div>
    </div>

    <b-modal v-model="modalSetCost" :header-bg-variant="'success'" centered hide-footer>
      <template >
        <b-row class="align-items-center mt--2">
          <b-col md="12" fluid class="mt--7">
              <h3 style="color: white;">Manual GP Cost Pairing</h3>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col lg="12">
          <base-input
              label="GP Unit Cost (SGD)"
              v-model="gp_item.gp_unit_cost_home"
          ></base-input>
        </b-col>
        <b-col lg="12">
          <b-button variant="success" @click="onClickSaveGPCost(1)">
            Ok
          </b-button>
          <b-button variant="danger" @click="onClickSaveGPCost(0)">
            Cancel
          </b-button>
          
        </b-col>
      </b-row>
    </b-modal>  

  </div>
</template>
<!--Must put this code to use auto complete component-->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Vue from 'vue';
import { Select, Option,Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import { mapState } from "vuex";
import productLookup from "@/components/Autocomplete.vue";
import tradeItemDespLookup from "@/components/Autocomplete.vue";

import moment from "moment";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// import printDocument from "../Components/printPdf.vue"

const item_is_collasped = false;

export default {
  props: {
    type: {
      type: String,
      default: "SQ",
      description: "Sales Type",
      required: true,
    },
    title: {
      type: String,
      default: "Sales Document",
      description: "Sale Document Title",
      required: true,
    }
  },
  data() {
    return {
      onSelectProduct_counter: 0,
      gp_item:{document_item_id:null, gp_unit_cost_home:null},
      gp_unit_cost_home: 0,
      modalSetCost:false,
      customer:[],
      modalReservations: false,
      modalGITSchedules: false,
      yesno:[
        {"value":"0","name":"No"},
        {"value":"1","name":"Yes"},
      ],
      modalAlternativeContactInfo: false,
      code_indicative:"",
      priceHistoryColumns:['Date', 'Document', 'Description', 'Currency', 'Qty', 'Unit Price'],
      priceHistoryOptions:{perPage:5, perPageValues:[],stickyHeader:false, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C',hiddenColumns:['id'],filterable:false},
      priceHistoryHeaders:['date'],
      sales_items_history_modal:false,
      sales_items_history_filter:{
        contact_id:"",
        type:""
      },    
      currentPage:1,
      filter: null,
      filterOn: [],
      bomTabelFields: [
            { key: 'index', label: 'SNO' },
            { key: 'product_code', label: 'PRODUCT_CODE' },
            { key: 'product_name', label: 'PRODUCT_NAME' },
            { key: 'qty', label: 'QTY' },
            { key: 'uom_code', label: 'UOM' },
            { key: 'price_adjustment', label: 'PRICE_ADJUSTMENT' },
            { key: 'is_default', label: 'IS_DEFAULT' },
            { key: 'is_included', label: 'IS_INCLUDE' }
            // { key: 'deleteBtn', label: 'ACTION' },
        ],
      document_mode:null,
      printouts_modal:false,
      revison_modal:false,
      milestones_modal:false,
      loading:false,
      selected_business_unit:{id:""},
      value: "",
      add_bom_modal:false,
      select_department_modal:false,
      bom_modal:{
        uom_code:"",
        qty:null,
        product_id:'',
        product_code:'',
        is_included:1,
        uom:''
      },
      is_edit:false,
      document_title: "",
      add_bom_index:-1,
      customers: [],
      products:[],
      loadingCounter: 0,
      apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
      salesTypes: [
        {
          label: "Quotation",
          value: "SQ",
        },
        {
          label: "Order",
          value: "SO",
        },
        {
          label: "Invoice",
          value: "SI",
        },
      ],
      selected_customer:null,
      desp_tags:[],
      tradeitem_desp_list:[],
      is_view_revision:0,
      nett_amount:"",
      gross_amount:"",
      tax_amount:"",
      discount_amount:"",
      reservations:{
        columns:
        [
          { key: 'date', label: 'Reserved Date', sortable: true, },
          { key: 'date_expired', label: 'Release Date', sortable: true, sortDirection: 'asc'},
          { key: 'qty', label: 'Qty', sortable: true},
          { key: 'document_code', label: 'Doc #'},
          { key: 'contact_name', label: 'Customer'},
          { key: 'salesperson_name', label: 'Salesperson'},
        ],
        items:[],
      },
      git_schedules:{
        columns:
        [
          { key: 'document_code', label: 'PO #'},
          { key: 'eta_date_yyyymmdd', label: 'ETA Date', sortable: true},
          { key: 'qty_slot', label: 'Qty', sortable: true, },
          // { key: 'eta_date_yyww', label: 'ETA (YYWW)', sortable: true, sortDirection: 'asc'},
          // { key: 'etd_date_yyww', label: 'ETD (YYWW)'},
          // { key: 'etd_date_yyyymmdd', label: 'ETD (YYYY-MM-DD)'},
          { key: 'Request By', label: 'Request By'},
          { key: 'document_remarks_internal', label: 'Internal Remarks'},
          { key: 'document_date', label: 'Order Date'},
        ],
        items:[],
      },
      items_history_fields:[
          { key: 'document_code', label: 'Inv #', sortable: true, sortDirection: 'desc' },
          { key: 'date', label: 'Date', sortable: true},
          { key: 'product_code', label: 'Item', sortable: true},
          { key: 'qty', label: 'Qty'},
          // { key: 'currency_code', label: 'Currency'},
          { key: 'unit_price', label: 'Unit Price'},
          { key: 'unit_discount', label: 'Unit Disc'},
          // { key: 'uom', label: 'UOM'},
          { key: 'is_selected', label: 'Select'},
      ],
      items_history:[],
      sales_document: {
        attention_to:'',
        i1:7,
        i2:30,
        s1:null,
        default_salesperson_contact_id:null,
        is_reserved:"0",
        alt_contact_name:null,
        alt_contact_address:null,
        code_indicative:'',
        discount_amount:"",
        discount_value:"",
        subtype:null,
        due_days_placeholder:"",
        revision_json:{},
        revision_id:null,
        time_printed:null,
        delivery_eta_date:null,
        action_edit:0,
        action_approval:0,
        require_approval:0,
        salesperson_contact_id:null,
        businessunit_contact_id:null,
        customer_credit_term:null,
        customer_credit_limit:null,
        customer_credit_limit_available:null,
        customer_amount_overdue:null,
        is_locked: false,
        is_approved: null,
        due_days: null,
        due_date: null,
        tax_code: "",
        tax_rate_percent: null,
        contact_id: null,
        customer: {},
        currency_code: "SGD",
        remarks:"",
        remarks_internal:"",
        items: [
          {
            sno: "1",
            is_trade:0,
            is_collapsed:item_is_collasped,
            reservation_max_days:null,
            trade_item:{},
            uom:"",
            uom_list:[],
            product:{id:"", code:"", name:""},
            bom_components:[],
            product_id: null,
            product_name: "",
            qty: "",
            sale_list_price:"",
            has_memo:"0",
            product_remarks:"",
            moq:"",
            unit_price: "",
            discount_amount: "",
            tax_amount: "",
            gross_amount: "",
            vendor:{id:"", code:"", name:""},
            vendor_contact_id: null,
            vendor_unit_price: null,
            vendor_sku: "",
            vendor_desp: "",
            vendor_currency_code: "",
            history:[],
            is_group_item:0,
          },
          // {
          //   sno: 2,
          //   is_trade:0,
          //   is_collapsed:item_is_collasped,
          //   reservation_max_days:null,
          //   trade_item:{},
          //   uom:"",
          //   uom_list:[],
          //   product:{id:"", code:"", name:""},
          //   bom_components:[],
          //   product_id: "",
          //   product_name: "",
          //   qty: "",
          //   sale_list_price:"",
          //   has_memo:"1",
          //   product_remarks:"",
          //   moq:"",
          //   unit_price: "",
          //   discount_amount: "",
          //   tax_amount: "",
          //   gross_amount: "",
          //   history:[],
          // },
          // {
          //   sno: 3,
          //   is_trade:0,
          //   is_collapsed:item_is_collasped,            
          //   reservation_max_days:null,
          //   trade_item:{},
          //   uom:"",
          //   uom_list:[],
          //   product:{id:"", code:"", name:""},
          //   bom_components:[],
          //   product_id: null,
          //   product_name: "",
          //   qty: "",
          //   sale_list_price:"",
          //   has_memo:"1",
          //   product_remarks:"",
          //   moq:"",
          //   unit_price: "",
          //   discount_amount: "",
          //   tax_amount: "",
          //   gross_amount: "",
          //   history:[],
          // }
        ],
        type: null,
      },
    };
  },
  components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dropdown.name]: Dropdown,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
      flatPicker,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      productLookup,
      tradeItemDespLookup,
      // printDocument,
      Loading
  },
  computed: {
    ...mapState({
        document_total: state => state.sales.document_total,
        bom_component_price: state => state.sales.bom_item_price,
        product_qty_available: state => state.stockcards.qty_available,
        revisions: state => state.documentRevisions.revisions, 
        revision_is_created: state => state.documentRevisions.revision_created,
        revision_is_retrieved: state => state.documentRevisions.is_retrieved,
        revision_data: state => state.documentRevisions.data,
        is_converted_so: state => state.sales.is_converted_so,
        is_converted_si: state => state.sales.is_converted_si,
        coverted_so_code: state => state.sales.coverted_so_code,
        coverted_si_code: state => state.sales.coverted_si_code,
        is_approved: state => state.sales.is_approved,
        is_rejected: state => state.sales.is_rejected,
        default_sq_validity_days: state => state.sales.default_sq_validity_days,
        // tradeitem_desp_list: state => state.products.tradeitem_desp_list,
        auth_user:state => state.auth.auth_user,
        salesperson_list:state => state.employees.salesperson_list,
        printouts: state => state.documentPrintouts.printouts,
        milestones: state => state.documentMilestones.milestones,
        sales_filter:state => state.sales.filter,
        sale_is_created: (state) => state.sales.is_created,
        sale_is_updated: (state) => state.sales.is_updated,
        business_units: (state) => state.customers.business_units,
        currencies: (state) => state.currencies.currencies,
        taxes: (state) => state.taxes.taxes,
        taxData: (state) => state.taxes.data,
        product_price: (state) => state.products.product_price,
        sale_doc: (state) => state.sales.document,
        language_terms: (state) => state.languages.language_terms,
        selected_lang: (state) => state.languages.selected_langauge,
        bom_components: (state) => state.productBom.bom_components,
        uom_list:state => state.products.uom_list, 
        is_copied:state => state.sales.is_copied,
        copied_code:state => state.sales.copied_code,
        sales_subtypes:state => state.sales.sales_subtypes,
        sale_items_history:state => state.sales.sale_items_history
    })
  },
  async mounted() 
  {
    this.loadingCounter++
    let document_id = this.$route.params.id;

    await this.$store.dispatch("sales/getDefaultSqValidityDays", {});
    await this.$store.dispatch("sales/getSalesSubTypes", {})

    if (document_id == "_new") 
    {
      this.document_title = "New " + this.$props.title;
      await this.getIndicativeCode()

      if(!this.sales_document.date)
      {
        this.sales_document.date = moment().format("YYYY-MM-DD");
      }

      if(!this.sales_document.delivery_eta_date)
      {
        this.sales_document.delivery_eta_date = moment().format("YYYY-MM-DD");
      }

      this.sales_document.due_days_placeholder = this.default_sq_validity_days

      if(this.sales_document.due_days)
        this.sales_document.due_date = moment(this.sales_document.date).add(this.sales_document.due_days, "days").format("YYYY-MM-DD");


      if(this.sales_document.date && this.sales_document.tax_code)
      {
        this.retrieveRate(this.sales_document.tax_code, this.sales_document.date)
        this.sales_document.tax_rate_percent = this.taxData.rate_percent
      }
      this.is_edit = true
    } 
    else 
    {
      // alert(this.$route.query.mode)      
      // this.document_mode = this.$route.query.mode;
      if (this.type && document_id) 
      {
        await this.retrieveDocument(document_id, this.type);
      }
      this.document_title = `${this.$props.title} (${document_id})`;
      this.document_mode = this.sales_document.status

      await this.asyncFindCustomer(this.sale_doc.contact_code);

      let selected_customer = {
        id: this.sales_document.contact_id,
        code: this.sales_document.contact_code,
        name: this.sales_document.contact_name,
        customer_tax_code: this.sales_document.contact_customer_tax_code,
      };

      this.sales_document.customer = selected_customer;
    
      if(this.sales_document.is_approved == 1) 
      {
        this.sales_document.is_locked = true;
      }

      let vm = this
      this.sales_document.items.forEach(function (element, index) {
        element.product = {id: element.product_id, name: element.product_name_master, code:element.product_code}
        element.product_last = {id: element.product_id, name: element.product_name_master, code:element.product_code}
        element.trade_item = {product_name: element.product_name, contact_id:null, date:null}
        if(element.is_trade == 1)
        {
            vm.addTag(element.product_name, index)
        }
        }
      );

      await this.viewRevisions()
      this.is_edit = false
    }

    await this.fetchCurrencies();
    await this.fetchTaxes();
    await this.fetchSalesPersons()
    await this.getAuthUser()

    if(this.auth_user)
    {
      if(!this.sales_document.salesperson_contact_id)
        this.sales_document.salesperson_contact_id = this.auth_user.contact_id
    }
    this.updateBomFiledTerms()

    this.loadingCounter--
  },
  watch:{
        language_terms: {
            handler(val){
                this.updateBomFiledTerms()
            },
            deep: true
        }
  },
  methods: 
  {
    async onClickSaveGPCost(state)
    {
      if (state == 1)
      {
        let payload = {document_item_id: this.gp_item.document_item_id, gp_unit_cost_home: this.gp_item.gp_unit_cost_home};
        axios.post(apiRoutes["SALES_SET_MANUAL_GP_UNIT_COST"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            location.reload(); 
          } 
          else 
          {

          }
        })
        .catch((error) => 
        {
          if (error.response) 
          {
            Vue.notify({group: "notify",type: "error",text: error.response, max: 5,duration: 5000,speed: 300,});
          } 
        });        
      }

      this.modalSetCost = false
    },
    async onClickSetCost(row)
    {
      if (this.auth_user.gp_access == 1)
      {
        this.gp_item.document_item_id = row.id
        this.gp_item.gp_unit_cost_home = row.cost_unit_price_home
        this.modalSetCost = true
      }
    },
    async onClickMoveUp(index, item)
    {
      if (index > 0)
      {
        this.onSelectProduct_counter+=2;

        let itm1 = JSON.parse(JSON.stringify(this.sales_document.items[index - 1]));
        let itm2 = JSON.parse(JSON.stringify(this.sales_document.items[index]));
        this.$set(this.sales_document.items, index, itm1);
        this.$set(this.sales_document.items, index - 1, itm2);

        // this.sales_document.items[index] = itm1
        // this.sales_document.items[index - 1] = itm2

        // this.$set(this.sales_document.items, index - 1, this.sales_document.items[index]);
        // this.$set(this.sales_document.items, index, itm);
        this.setSNo()

      }
    },
    async onClickMoveDown(index, item)
    {
      if (index < this.sales_document.items.length - 1)
      {
        this.onSelectProduct_counter+=2;
        
        // let itm1 = JSON.parse(JSON.stringify(this.sales_document.items[index]));
        // let itm2 = JSON.parse(JSON.stringify(this.sales_document.items[index + 1]));
        // console.log(itm1)
        // console.log(itm2)

        // this.sales_document.items[index+1] = itm1
        // this.sales_document.items[index] = itm2
        
        // await this.$set(this.sales_document.items, index + 1, itm1);
        // await this.$set(this.sales_document.items, index, itm2);

        // console.log(this.sales_document.items[index])
        // console.log(this.sales_document.items[index + 1])

        await this.sales_document.items.splice(index, 1, this.sales_document.items[index + 1]);
        await this.sales_document.items.splice(index + 1, 1, item);        
        await this.setSNo()
        // await this.calDocumentTotal()

      }
      else
      alert('not allowed')

      // if (index < this.sales_document.items.length - 1)
      // {
      //   console.log(this.sales_document.items[index])

      //   // Swap the items using splice()
      //   // this.sales_document.items.splice(index, 1, this.sales_document.items[index + 1]);
      //   // this.sales_document.items.splice(index + 1, 1, item);

      //   // this.setSNo();
      // } 
      // else
      // {
      //   alert('not allowed');
      // }
    },
    async newSaleDocument()
    {
      if (this.sales_document.type == 'SI')
        window.location.href = "/sales/sales-invoice/_new"
      else if (this.sales_document.type == 'SQ')
        window.location.href = "/sales/sales-quotation/_new"
    
    },
    async setSNo()
    {
      let major = 0;
      let minor = 0;

      for (var x = 0; x < this.sales_document.items.length; x++)
      {
        var is_group_item = this.sales_document.items[x].is_group_item
        // alert(this.sales_document.items[x].is_group_item)
        if (x == 0)
        {
          major++
        }
        else if (is_group_item == 1)
        {
          minor++
        }
        else
        {          
          major++;
          minor = 0;
        }

        var sno = major;
        if (minor > 0)
          sno = sno + "." + minor
        // sno = major + "." + minor
        // alert(x + 1 + " " + major + " " + minor)

        this.sales_document.items[x].sno = sno
      }
    },
    async onClickGroupItem(index)
    {
      this.setSNo()      
    },
    async showReservations(item)
    {
      if (item.product_id != null)
      {
        let payload = {product_id: item.product_id};
        axios.post(apiRoutes["SALES_RETRIEVE_PRODUCT_RESERVATIONS"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.reservations.items = response.data.data
            if (this.reservations.items.length > 0)
              this.modalReservations = true

          } 
          else 
          {
            this.reservations.items = []
          }
        })
        .catch((error) => 
        {
          if (error.response) 
          {
            Vue.notify({group: "notify",type: "error",text: error.response, max: 5,duration: 5000,speed: 300,});
          } 
        });
      }
    },
    async showGITSchedules(item)
    {
      if (item.product_id != null)
      {
        let payload = {product_id: item.product_id};
        axios.post(apiRoutes["PURCHASE_RETRIEVE_GIT_SCHEDULES"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.git_schedules.items = response.data.data
            if (this.git_schedules.items.length > 0)
              this.modalGITSchedules = true

          } 
          else 
          {
            this.git_schedules.items = []
          }
        })
        .catch((error) => 
        {
          if (error.response) 
          {
            Vue.notify({group: "notify",type: "error",text: error.response, max: 5,duration: 5000,speed: 300,});
          } 
        });
      }
    },
    async onClickContactSub()
    {
      this.modalAlternativeContactInfo = true
    },
    async getIndicativeCode()
      {
        let payload = {type: this.type};
        let code = null

        axios.post(apiRoutes["DOCUMENT_GET_CODE"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            code = response.data.msg
            this.code_indicative = code
            if (code != '')
            {
              code = code.replace('[CLASSIFICATION]', '')
              this.document_title += ' (' + code + ')';
            }
          } 
          else 
          {
            this.purchase_document.code_indicative = ''
          }
        })
        .catch((error) => 
        {
          if (error.response) 
          {
            Vue.notify({group: "notify",type: "error",text: error.response, max: 5,duration: 5000,speed: 300,});
          } 
        });

        return code
    },      
    onFiltered(filteredItems) {
      this.currentPage = 1
    },
    cancelItemsHistoryModal()
    {
      this.sales_items_history_modal = false
    },
    async addToItems()
    {
      await this.removeEmptyItems()
      let is_trade = null
      for(let x = 0; x < this.items_history.length; x++)
      {
        if(this.items_history[x]['is_selected'] == "1")
        {
          let product_id = this.items_history[x]['product_id']
          let product_code = this.items_history[x]['product_code']
          let product_name = this.items_history[x]['product_name']
          let qty = null //this.items_history[x]['qty']
          let uom = this.items_history[x]['uom']

          let trade_item = {}
          if(this.items_history[x]['is_trade'] == "1")
          {
            is_trade = 1
            trade_item = {product_name: product_name, contact_id:null, date:null}              
          }
          else
          {
            is_trade = 0
            trade_item = {product_name: null, contact_id:null, date:null}              
          }
          
          let item = {
            sno: null,
            is_trade:is_trade,
            is_collapsed:item_is_collasped,
            reservation_max_days:null,
            trade_item:trade_item,
            uom:uom,
            uom_list:[],
            product:{id:null, code:null, name:null},
            bom_components:[],
            product_id: null,
            product_name: null,
            qty: qty,
            sale_list_price:0,
            has_memo:"1",
            product_remarks:"",
            moq:0,
            unit_price: 0,
            discount_amount: 0,
            tax_amount: 0,
            gross_amount: 0,
            vendor:{id:"", code:"", name:""},
            vendor_contact_id: null,
            vendor_unit_price: null,
            vendor_sku: "",
            vendor_desp: "",
            vendor_currency_code: "",
            history:[],
            is_group_item:0,            
          }
          this.sales_document.items.push(item);
          let product = {id:product_id, code:product_code, name:null}
          this.onSelectProduct(product, this.sales_document.items.length-1)
        }
      }

      this.setSNo()
      this.sales_items_history_modal = false
    },
    removeEmptyItems()
    {
      if (this.sales_document.items.length > 1)
      {
        let items = []
        for(let x = 0; x < this.sales_document.items.length; x++)
        {
          let item = this.sales_document.items[x]
          if(this.sales_document.items[x].product_id != '' && this.sales_document.items[x].product_id != null)
          {
            items.push(item)
          }
        }

        this.sales_document.items = items
      }
    },
    async viewOrderHistory()
    {
      this.sales_items_history_filter = {contact_id: this.sales_document.contact_id, type: this.$props.type}
      await this.$store.dispatch("sales/fetchSaleItemsHistoryForCustomer", this.sales_items_history_filter)

      this.items_history = this.sale_items_history

      this.sales_items_history_modal = true
    },
    hasIncludedCount(items)
    {
        let count = 0;

        for(let x = 0; x < items.length; x++)
        {
            if(items[x].is_included == '1')
            {
                count++;
            }
        }

        return count
    },
    updateBomFiledTerms()
    {
        for(let i = 0; i< this.bomTabelFields.length; i++)
        {
            this.bomTabelFields[i].label = this.language_terms[this.bomTabelFields[i].label]
        }
    },
    async setBomItemInclude(bom_item_index, group_index, s_index, row)
    {
        let bom_items = this.sales_document.items[s_index].bom_components[group_index].boms
        let count = this.hasIncludedCount(bom_items)
        let max_selection_count = this.sales_document.items[s_index].bom_components[group_index].max_selection_count

        if(this.sales_document.items[s_index].bom_components[group_index].boms[bom_item_index].is_included == '1')
        {
            if(count <= max_selection_count)
            {
              this.sales_document.items[s_index].bom_components[group_index].boms[bom_item_index].is_included = 1
            }
            else
            {
              this.sales_document.items[s_index].bom_components[group_index].boms[bom_item_index].is_included = 0
            }

            await this.$store.dispatch("sales/getBomItemPrice", 
                                                  {
                                                      sale_item:this.sales_document.items[s_index], 
                                                      contact_id:this.sales_document.contact_id, 
                                                      date:this.sales_document.date,
                                                      currency_code:this.sales_document.currency_code
                                                  }
                                      )
            let data = this.sales_document.items[s_index];
            data.unit_price_placeholder =  parseFloat(this.bom_component_price);
            this.$set(this.sales_document.items, s_index , data)

            await this.calDocumentTotal();
        }

    },
    async calDocumentTotal()
    {
      await this.$store.dispatch("sales/cal_document_total", this.sales_document)      
      if(this.document_total)
      {
        // this.sales_document.items[index].unit_discount = (unit_discount <= 0) ? 0 : (unit_discount * 1).toFixed(2)
        if (!isNaN(this.gross_amount))
          this.gross_amount = this.document_total.sub_total.toFixed(2)
        
        if (!isNaN(this.nett_amount))
          this.nett_amount = this.document_total.nett_amount.toFixed(2)

        if (!isNaN(this.tax_amount))
          this.tax_amount = this.document_total.tax_amount.toFixed(2)

        if (!isNaN(this.discount_amount))
          this.discount_amount = this.document_total.discount_amount.toFixed(2)
      }
    },
    removeBomItemFromGroup(bom_item_index, group_index, s_index)
    {
      this.sales_document.items[s_index].bom_components[group_index].boms.splice(bom_item_index, 1)    
    },
    deleteBomGroup(index, j)
    {
      if (index != -1) 
      {
        this.sales_document.items[index].splice(j, 1)
      }
    },
    handleCollapseBomGroup(s_index, bom_index, row)
    {
        row.is_collapsed_bom_item = !row.is_collapsed_bom_item
        this.$set(this.sales_document.items[s_index].bom_components, bom_index , row) 
    },
    async copyDocument()
    {
      this.loadingCounter ++

      this.sales_document.document_id = this.sales_document.id
      await this.$store.dispatch("sales/copy", this.sales_document);
      if(this.is_copied)
      {
        // this.$router.push("/sales/sales-order/" + this.copied_code)
        // this.$router.push("/sales/sales-quotation/" + this.copied_code)
        window.location.href = "/sales/sales-quotation/" + this.copied_code
      }

      this.loadingCounter--
    },
    startsWith(str, word) {
        return str.lastIndexOf(word, 0) === 0;
    },
    async viewRevisionDoc(revision)
    {
      this.loadingCounter ++

      this.revison_modal = false

      if(revision)
      {
        let doc = revision.data_json

        await this.$store.dispatch("documentRevisions/fetch", {revision_id: revision.id});

        if(this.revision_is_retrieved)
        {
            let document_id = `${doc.code} - ${this.language_terms['REVISION']} ${revision.revision}`
            this.document_title = `${this.$props.title} (${document_id})`;

            if(revision.is_current == 1)
            {
                this.is_view_revision = 0
                await this.retrieveDocument(doc.code, this.type)
            }
            else
            {
                this.is_view_revision = 1;
                doc.revision_id = revision.id;
                this.sales_document = this.revision_data.data_json;
            }
            
          await this.asyncFindCustomer(this.sale_doc.contact_code);
          let selected_customer = 
          {
            id: this.sales_document.contact_id,
            code: this.sales_document.contact_code,
            name: this.sales_document.contact_name,
            customer_tax_code: this.sales_document.contact_customer_tax_code,
          };

          this.sales_document.customer = selected_customer;

          // if(this.sales_document.is_approved == 1) 
          // {
          //   this.sales_document.is_locked = 1;
          // }
          let vm = this
          this.sales_document.items.forEach(function (element, index) {
            element.product = {id: element.product_id, name: element.product_name_master, code:element.product_code}
            element.trade_item = {product_name: element.product_name, contact_id:null, date:null}
            if(element.is_trade == 1)
            {
                vm.addTag(element.product_name, index)
            }
          });

        }


      }

      this.loadingCounter--
    },
    async viewRevisions()
    {
      await this.$store.dispatch('documentRevisions/fetchAll', {document_id:this.sales_document.id});

      //this.revison_modal = true

    },
    getMilestoneClass(milestone)
    {
        let classname = 'statusopen';

        if(milestone.status == 'OPEN')
        {
          classname = 'statusopen';
        }
        else if(milestone.status == 'PENDING_APPROVAL')
        {
          classname = 'statuspendingapproval';
        }
        else if(milestone.status == 'APPROVED')
        {
          classname = "statusapproved"
        }
        else if(milestone.status == 'REJECTED')
        {
          classname = "statusrejected"
        }
        else if(milestone.status == 'REVISED')
        {
          classname = "statusrevised"
        }


        return classname
    },
    getMilestoneTxtStyle(milestone)
    {
        let style = "color:black;font-weight:bold;"

        // if(milestone.status == 'OPEN')
        // {
        //   style = "color:#22c0e8;font-weight:bold;"
        // }
        // else if(milestone.status == 'PENDING_APPROVAL')
        // {
        //   style = "color:#ffc107;font-weight:bold;"
        // }
        // else if(milestone.status == 'APPROVED')
        // {
        //   style = "color:#2dce89;font-weight:bold;"
        // }
        // else if(milestone.status == 'REVISED')
        // {
        //   style = "color:#5603ad;font-weight:bold;"
        // }

        return style
    },
    async viewDocumentMilestones()
    {
      await this.$store.dispatch("documentMilestones/fetchAll", {document_id:this.sales_document.id})
      this.milestones_modal = true
    },
    isFoundInList(name)
    {
        let is_found = 0
        for(let i = 0; i < this.desp_tags.length; i++)
        {
            if(this.desp_tags[i].product_name == name)
            {
              is_found = 1
            }
        }
        return is_found;
    },
    async addTag(newTag, index)
    {
      if(newTag)
      {
        let obj = {product_name: newTag, contact_id:this.sales_document.contact_id, date:this.sales_document.date}


        if(this.isFoundInList(newTag) == 0)
        {
            this.desp_tags.push(obj)
            Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags)
            this.sales_document.items[index].trade_item = obj
           
            this.sales_document.items[index].product_name = newTag
            let product_id = this.sales_document.items[index].product_id

            //await this.$store.dispatch('stockcards/getProductAvailableQty', {product_id:product_id, product_name: newTag, date:this.sales_document.date})
            // xxxx
            // this.sales_document.items[index].qty_available = this.product.qty_available
            // this.sales_document.items[index].qty_reserved = this.product.qty_reserved
            // this.sales_document.items[index].qty_git = this.product.qty_git
        }

      }
    },
    async getAuthUser()
    {
      await this.$store.dispatch("auth/getAuthUser", {})
    },
    onChangeUom(item, index)
    {
        // console.log("onChangeUom")
        // console.log(item)
        // console.log(index)
    },
    async convertToSO(){
      this.loadingCounter++
      await this.$store.dispatch("sales/convertToSO", {document_id: this.sales_document.id})
      if(this.is_converted_so)
      {

          // setTimeout( () => {
          //      this.loadingCounter++
          //     }, 50000);
          this.$router.push("/sales/sales-order/" + this.coverted_so_code)

      }
      this.loadingCounter--

    },
    async convertToSI(){
      this.loadingCounter++
      await this.$store.dispatch("sales/convertToSI", {document_id: this.sales_document.id})
      if(this.is_converted_si)
      {
          this.$router.push("/sales/sales-invoice/" + this.coverted_si_code)
      }
      else
      {
        // alert('Sales Quotation is already approved')
      }
      this.loadingCounter--
    },
    validateReservationDays(item, index)
    {
      if(item.reservation_days != '' && item.reservation_max_days != null)
      {
          item.reservation_days = item.reservation_days * 1;
          item.reservation_max_days = item.reservation_max_days * 1;
         if(item.reservation_days > item.reservation_max_days)
         {
            item.reservation_days = item.reservation_max_days;
            this.$set(this.sales_document.items, index , item) 
         }
      }
    },
    async viewDocumentPrintOuts()
    {
        // retrieve printouts
        this.loadingCounter++
        await this.$store.dispatch("documentPrintouts/fetchAll", {document_id: this.sales_document.id});
        this.printouts_modal = true
        this.loadingCounter--
    },
    async searchSales()
    {
        this.loadingCounter++
        let filter = {
                        keyword:"",
                        date_from:null,
                        date_to:null,
                        type:this.sales_document.type,
                        status:'ALL'
                      }
        if(this.sales_filter)
        {
            filter = this.sales_filter
        }
        await this.$store.dispatch('sales/quickSearch', filter)

        this.loadingCounter--
    },
    async onChangeBusinessUnit()
    {
      if(this.selected_business_unit.id)
      {
        this.sales_document.contact_id = this.selected_business_unit.id;
        this.sales_document.contact_code = this.selected_business_unit.code
        this.sales_document.contact_name = this.selected_business_unit.name

        this.sales_document.tax_code = this.selected_business_unit.customer_tax_code;
        await this.onChangeTaxCode(this.selected_business_unit.customer_tax_code);
      }
    },
    cancelBomSave()
    {
        this.bom_modal = {
            uom_code:"",
            qty:null,
            product_id:'',
            product_code:'',
            is_included:1
        }
        this.add_bom_modal = false
    },
    addBomSave()
    {
        if(this.add_bom_index != -1 && this.bom_modal.product_id && this.bom_modal.qty)
        {
          this.sales_document.items[this.add_bom_index].bom_components.push(this.bom_modal)
          this.add_bom_modal = false
        }
        else
        {
          alert("Please input product, qty")
          this.add_bom_modal = false
        }
    },
    async selectBomProduct(obj)
    {
        
        if(obj)
        {
          this.bom_modal.product_id = obj.id
          this.bom_modal.product_code = obj.code
          this.bom_modal.product_name = obj.name

            await this.$store.dispatch("products/listUoms", {product_id:obj.id})
            if(this.uom_list.length > 0)
            {
              this.bom_modal.uom = this.uom_list[0]
            }
        }
    },
    async retrieveUomList(product_id)
    {
        let uom_list = []
        await this.$store.dispatch("products/listUoms", {product_id:product_id})
        if(this.uom_list.length > 0)
        {
            uom_list = this.uom_list
        }

        return uom_list
    },
    addBomComponent(index)
    {
      this.add_bom_modal = true
      this.add_bom_index = index
    },
    deleteBomComponent(i, j)
    {
        this.sales_document.items[i].bom_components.splice(j, 1);
    },
    toggleMemo(check, index)
    {
      if(check == 0)
      {
        this.sales_document.items[index]['product_remarks'] = ""
      }

      // this.sales_document.items[index].is_collapsed  = false

    },
    productNameWithCode ({ name, code }) {
      if(name || code)
        return `${name} :: ${code}`
    },
    customerNameWithCode ({ name, code }) {
      if(name || code)
        return `${name} (${code})`
    },
    async approveDocument()
    {
        await this.$store.dispatch("sales/approveDocument", {document_id:this.sales_document.id})

        if(this.is_approved)
        {
          await this.searchSales();
          this.routeToMaster()
        } 
    },
    async rejectDocument()
    {
        this.$store.dispatch("sales/rejectDocument", {document_id:this.sales_document.id})
        if(this.is_rejected)
        {
           await this.searchSales();
           this.routeToMaster()
        } 
    },
    printGP()
    {
      this.loadingCounter++
      let type = this.sales_document.type
      if (type == 'SQ')
      {
        let url = 'https://reports.unityerp.com/esteam/sales-invoice-gp/' + encodeURIComponent(localStorage.access_token)
        + '/' + encodeURIComponent(this.sales_document.code)
        window.open(url , '_blank');
      }
      else if (type  == 'SI')
      {
        let url = 'https://reports.unityerp.com/esteam/sales-invoice-gp/' + encodeURIComponent(localStorage.access_token) 
        + '/' + encodeURIComponent(this.sales_document.code)
        window.open(url , '_blank');
      }
      this.loadingCounter--
    },
    printDocument(isDraft)
    {
      this.loadingCounter++
      let document_id = this.sales_document.id;
      if (isDraft == 0)
      {
        this.$store.dispatch("documentMilestones/print", {document_id: document_id, });
        this.sales_document.is_printed = 1
      }
                
      let type = this.sales_document.type
      if (type == 'SQ')
      {
        let contact_name = this.sales_document.contact_name.replace('*', '')
        let url = 'https://reports.unityerp.com/esteam/sales-quotation/' + encodeURIComponent(localStorage.access_token)
        + '/' + encodeURIComponent(this.sales_document.code)
        + '/' + encodeURIComponent(this.sales_document.code + ' - ' + contact_name)
        
        window.open(url , '_blank');
      }
      else if (type  == 'SI')
      {
        let url = 'https://reports.unityerp.com/esteam/sales-invoice/' + encodeURIComponent(localStorage.access_token) 
        + '/' + encodeURIComponent(this.sales_document.code) + '/' + isDraft
        window.open(url , '_blank');
      }
      this.loadingCounter--
    },
    async editDocument()
    {
      // alert(this.sales_document.items.length)
      this.loadingCounter++
      // this.onSelectProduct_counter = this.sales_document.items.length
      // alert(this.onSelectProduct_counter)
      await this.setSNo();
      await this.calDocumentTotal()
      this.is_edit = true
      this.loadingCounter--
    },
    async retrieveDocument(code, type) {
      await this.$store.dispatch("sales/fetch", {
        code: code,
        type: type,
      });

      this.sales_document = this.sale_doc;
    },
    async onChangeField(row, index)
    {
      if((row.qty || row.unit_price) && row.product_id)
      {
          let unit_price = row.unit_price * 1;

          let product_id = row.product_id
          let qty = row.qty * 1;
          let uom = row.uom; 
          let product_price = await this.retrieveProductPrice(product_id, this.sales_document.contact_id, qty, uom, row.bom_components);
          let sale_list_price = product_price.sale_list_price;
          await this.$store.dispatch("sales/getBomItemPrice", 
              {
                  sale_item:this.sales_document.items[index], 
                  contact_id:this.sales_document.contact_id, 
                  date:this.sales_document.date,
                  currency_code:this.sales_document.currency_code
              }
          )

          // if(this.bom_component_price)
          // {
          //   this.sales_document.items[index].unit_price_recommended = (this.bom_component_price * 1).toFixed(2)
          //   this.sales_document.items[index].unit_price_placeholder = (this.bom_component_price * 1).toFixed(2)

          // }
          // else
          // {
          //   this.sales_document.items[index].unit_price_recommended = (product_price.unit_price * 1).toFixed(2)
          //   this.sales_document.items[index].unit_price_placeholder = (product_price.unit_price * 1).toFixed(2)
          // }
          this.sales_document.items[index].unit_price_recommended = (product_price.unit_price * 1).toFixed(2)
          this.sales_document.items[index].unit_price_placeholder = (product_price.unit_price * 1).toFixed(2)

          this.sales_document.items[index].sale_list_price = isNaN(product_price.sale_list_price) ? 0 : product_price.sale_list_price          
          this.sales_document.items[index].sale_list_price_display = (product_price.sale_list_price !='' && product_price.sale_list_price != null) ? product_price.sale_list_price: '-'
          let unit_discount = product_price.unit_discount;

          qty = product_price.qty * 1;

          let gross_amount = product_price.total_amount;

          if(unit_price)
          {
            gross_amount = qty * unit_price;
            unit_discount = sale_list_price - unit_price;
          }
          this.sales_document.items[index].qty = qty
          this.sales_document.items[index].gross_amount = (gross_amount * 1).toFixed(2)
          this.sales_document.items[index].unit_discount = (unit_discount <= 0) ? 0 : (unit_discount * 1).toFixed(2)

          await this.calDocumentTotal();

      }
    },
    async onChangeValidityDays() 
    {
      this.sales_document.due_date = moment(this.sales_document.date).add(this.sales_document.due_days, "days").format("YYYY-MM-DD");
    },
    async onChangeDate() 
    {
      if (this.sales_document.date) 
      {
        if (this.sales_document.tax_code)
        {
          await this.retrieveRate(this.sales_document.tax_code,this.sales_document.date);
          this.sales_document.tax_rate_percent = this.taxData.rate_percent
        }

        this.onChangeValidityDays();
      }
    },
    async retrieveProductPrice(product_id, customer_id, qty, uom, bom_components) 
    {
      let price = null;

      await this.$store.dispatch("products/fetchProductPrice", 
        {
          product_id: product_id,
          contact_id: customer_id,
          date: this.sales_document.date,
          qty:qty,
          currency_code: this.sales_document.currency_code,
          uom:uom,
          bom_components:bom_components
        });

      return this.product_price;
    },
    async onChangeTaxCode() 
    {
      if (this.sales_document.tax_code) 
      {
        await this.retrieveRate(
          this.sales_document.tax_code,
          this.sales_document.date
        );
        this.sales_document.tax_rate_percent = this.taxData.rate_percent
      }
    },
    async retrieveRate(code, date) 
    {
      await this.$store.dispatch("taxes/fetch", { code: code, date: date });
      this.sales_document.tax_rate_percent = this.taxData.rate_percent;
    },
    async onSelectVendor(selectedOption, index) {
      if (selectedOption) 
      {
        if(selectedOption.id)
        {
          this.sales_document.items[index].vendor_contact_id = selectedOption.id
        }
      }
    },    
    async onSelectCustomer(selectedOption) {
      if (selectedOption) 
      {
        if(selectedOption.id)
        {
          this.customer = selectedOption
          this.sales_document.default_salesperson_contact_id = selectedOption.default_salesperson_contact_id
          this.sales_document.subtype = selectedOption.classification

          this.sales_document.alt_contact_name = selectedOption.alt_contact_name
          this.sales_document.alt_contact_address = selectedOption.alt_contact_address
        
          this.selected_business_unit = {id:""}
          await this.$store.dispatch("customers/fetchBusinessUnits", {parent_id: selectedOption.id});

          if(this.business_units.length > 1)
          {
              this.sales_document.businessunit_contact_id = this.business_units[0].id
              this.sales_document.contact_id = selectedOption.id;
          }
          else
          {
              this.sales_document.contact_id = selectedOption.id;
              this.sales_document.tax_code = selectedOption.customer_tax_code;
              this.sales_document.currency_code = selectedOption.currency_code;
              this.sales_document.customer_credit_term = selectedOption.customer_credit_term;
              this.sales_document.customer_credit_limit = selectedOption.customer_credit_limit;
              this.sales_document.customer_credit_limit_available = selectedOption.customer_credit_limit_available;
              this.sales_document.customer_amount_overdue = selectedOption.customer_amount_overdue
              this.sales_document.attention_to = selectedOption.contact_person
              this.sales_document.salesperson_contact_id = selectedOption.default_salesperson_contact_id
              await this.retrieveRate(this.sales_document.tax_code, this.sales_document.date)
              this.sales_document.tax_rate_percent = this.taxData.rate_percent

              // Reapply prices
              this.reapplyItemPrices()

              // console.log(this.sales_document)
              // await this.onChangeTaxCode(selectedOption.customer_tax_code);
          }
        }
      }
    },
    reapplyItemPrices()
    {

    },
    fetchSalesPersons() {
      this.$store.dispatch("employees/fetchAllSalesPerson", {"role_code":"Sales Person"});
    },
    fetchCurrencies() {
      this.$store.dispatch("currencies/fetchAll", {});
    },
    fetchTaxes() {
      this.$store.dispatch("taxes/fetchAll", { type: "Sales" });
    },
    limitText(count) {
      return `and ${count} other countries`;
    },
    addSaleItems() {
      let sale_items_length = this.sales_document.items.length;
      let item = {
        // sno: sale_items_length + 1,
        sno: null,
        is_trade:0,
        product:{id:"", code:"", name:""},
        reservation_max_days:null,
        uom:"",
        product_id: "",
        product_name: "",
        qty: "",
        has_memo:"0",
        product_remarks:"",
        sale_list_price:"",
        moq:"",
        unit_price: "",
        discount_amount: "",
        tax_amount: "",
        gross_amount: "",
        bom_components:[],
        uom_list:[],
        is_collapsed:item_is_collasped,
        trade_item:{},
        history:[],
        is_group_item:0,        
      };

      this.sales_document.items.push(item);
      this.setSNo()
    },
    handleCollapse(index, row)
    {
      row.is_collapsed = !row.is_collapsed
      this.$set(this.sales_document.items, index , row) 
    },
    handleInsertBefore(index, row)
    {
      let sale_items_length = this.sales_document.items.length;
      let item = {
        // sno: sale_items_length + 1,
        sno: null,
        is_trade:0,
        product:{id:"", code:"", name:""},
        reservation_max_days:null,
        uom:"",
        product_id: "",
        product_name: "",
        qty: "",
        has_memo:"0",
        product_remarks:"",
        sale_list_price:"",
        moq:"",
        unit_price: "",
        discount_amount: "",
        tax_amount: "",
        gross_amount: "",
        bom_components:[],
        uom_list:[],
        is_collapsed:item_is_collasped,
        trade_item:{},
        history:[],
        is_group_item:0,        
      };

      this.sales_document.items.splice(index, 0, item);
      this.setSNo()

    },
    async handleDelete(index, row) 
    {
      this.loadingCounter ++
      this.onSelectProduct_counter = (this.sales_document.items.length - index) - 1
      // alert("delete " + this.onSelectProduct_counter)

      this.sales_document.items.splice(index, 1);
      await this.setSNo();

      this.loadingCounter --
    },
    async onClickSave() 
    {
      if (this.$route.params.id == "_new") 
      {
        this.loadingCounter ++
        this.sales_document.type = this.type;
        await this.$store.dispatch("sales/create", this.sales_document);
        this.loadingCounter --

        if(this.sale_is_created)
        {
            await this.searchSales();
            this.routeToMaster();
        }

      } 
      else 
      {
        this.loadingCounter ++
        this.sales_document.type = this.type;

        await this.$store.dispatch("sales/update", this.sales_document);
        if(this.sale_is_updated == "1")
        {
            // await this.searchSales();
            // this.routeToMaster();
            // location.reload();
            this.is_edit = false
            location.reload();            
        }
        this.loadingCounter --
      }
    },
    routeToMaster() 
    {
      if (this.type == "SQ") 
      {
        this.$router.push("/sales/sales-quotations");
      } 
      else if (this.type == "SO") 
      {
        this.$router.push("/sales/sales-orders");
      } 
      else if (this.type == "SI") 
      {
        this.$router.push("/sales/sales-invoices");
      }
    },
    cancelDocument() 
    {

      if(this.$route.params.id == '_new')
      {
        this.routeToMaster()
      }
      else
      {
        location.reload();
      }
      
    },
    backDocument(){
      this.routeToMaster()
    },
    async onSelectProduct(product, index)
    {
      this.loadingCounter++
      // alert(this.onSelectProduct_counter)
      if (this.onSelectProduct_counter == 0)
      {
        let item = this.sales_document.items[index]

        if (product.id)
        {
          this.loadingCounter++

          // Retrieve UOM List
          let uom_list = product.uoms; //await this.retrieveUomList(product.id)
          
          if (this.is_edit && this.sales_document.items[index].product.code != product.code)
          {
            this.sales_document.items[index].unit_price = null
            this.sales_document.items[index].product_name = null
          }

          let product_id = product.id
          let product_code = product.code
          let name = item.name

          let uom = ''
          // alert('item.uom = ' + item.uom)
          // alert(item.uom)
          
          // alert(uom_list.length)
          if (uom_list.length == 1)
            uom = product.uom
          else
          {
            if (item.uom === undefined || item.uom == '')        
              uom = product.uom
            else
              uom = item.uom
          }

          let reservation_max_days = product.reservation_max_days
          let is_bom_configurable = product.is_bom_configurable
          let is_trade = product.is_trade
          //await this.$store.dispatch('stockcards/getProductAvailableQty', {product_id:product_id, product_name: name, date:this.sales_document.date })
          this.sales_document.items[index].qty_available = product.qty_available
          this.sales_document.items[index].qty_reserved = product.qty_reserved
          this.sales_document.items[index].qty_git = product.qty_git
          
          this.sales_document.items[index].name = name
          this.sales_document.items[index].uom = uom
          this.sales_document.items[index].reservation_max_days = reservation_max_days
          this.sales_document.items[index].is_bom_configurable = is_bom_configurable
          this.sales_document.items[index].is_trade = is_trade

          // MOQ Display
          let moq = product.moq
          this.sales_document.items[index].moq_display = (moq !='' && moq != null) ? moq: '-'

          let qty = (this.sales_document.items[index].qty != '' && this.sales_document.items[index].qty != null) ? this.sales_document.items[index].qty : 0

          // alert(uom_list)
          // console.log(uom_list)
          this.sales_document.items[index].uom_list = uom_list
          if(item.bom_components.length > 0)
          {
              if(item.product_id != product.id)
              {
                  this.sales_document.items[index].bom_components = []
                  await this.$store.dispatch("productBom/fetchComponents", {parent_product_id:product.id})
                  this.sales_document.items[index].bom_components = this.bom_components
              }
          }
          else
          {
              // await this.$store.dispatch("productBom/fetchComponents", {parent_product_id:product.id})
              this.sales_document.items[index].bom_components = []; //this.bom_components
          }

          // OPTIMIZE 2024-04-06
          let product_price = await this.retrieveProductPrice(product_id, this.sales_document.contact_id, qty, uom, this.sales_document.items[index].bom_components);
          this.sales_document.items[index].history = product_price.history
          let sale_list_price = product_price.sale_list_price;

          let unit_price  = this.sales_document.items[index].unit_price

          this.sales_document.items[index].unit_price_placeholder = (product_price.unit_price * 1).toFixed(2)
          this.sales_document.items[index].unit_price_recommended = (product_price.unit_price * 1).toFixed(2)

          this.sales_document.items[index].sale_list_price = product_price.sale_list_price
          this.sales_document.items[index].sale_list_price_display = (product_price.sale_list_price !='' && product_price.sale_list_price != null) ? product_price.sale_list_price: '-'
          let unit_discount = product_price.unit_discount;

          let gross_amount = product_price.total_amount;

          if(unit_price)
          {
            gross_amount = qty * unit_price;
            unit_discount = sale_list_price - unit_price;
          }

          this.sales_document.items[index].gross_amount = (gross_amount * 1).toFixed(2)
          this.sales_document.items[index].unit_discount = (unit_discount <= 0) ? 0 : (unit_discount * 1).toFixed(2)

          if(product.is_bom == 1 || product.is_bom == "1")
          {
            // retrieve BOM
            //console.log(item.bom_components)
          }
          else
          {
            this.sales_document.items[index].bom_components = []
          }
            
          this.sales_document.items[index].product_id = product_id
          this.sales_document.items[index].product_code = product_code

          let row = this.sales_document.items[index]
          this.$set(this.sales_document.items, index , row) 
          
          // OPTIMIZE - 2024-03-28
          // await this.calDocumentTotal();
          this.loadingCounter--
        }
      }
      else
      {
        // alert('reduce counter')
        this.onSelectProduct_counter--
      }
        

      this.loadingCounter--
    },
    async asyncFindProduct(query) {
      this.loadingCounter++;
      let pv = { value: query };
      if(query)
      {
          await axios
          .post(apiRoutes["PRODUCT_LOOKUP"], pv, authHeader())
          .then((response) => 
          {
            if (response.data.code == 1) {
              this.products = response.data.data;
            } 
            else 
            {
              this.products = [];
            }

          })
          .catch((error) => {
            if (error.response) {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
          });

          
      }
      this.loadingCounter--;

    },
    async onSelectTradeItemDesp(selectedOption, index)
    {
        if(selectedOption)
        {
          let item = this.sales_document.items[index]
          item.product_name = selectedOption.product_name
          //await this.$store.dispatch('stockcards/getProductAvailableQty', {product_id:item.product_id, product_name: item.product_name, date:this.sales_document.date, })
          // item.qty_available = this.product_qty_available

          // this.sales_document.items[index].qty_available = this.product.qty_available          
          // this.sales_document.items[index].qty_reserved = this.product.qty_reserved
          // this.sales_document.items[index].qty_git = this.product.qty_git          

          this.$set(this.sales_document.items, index , item) 
        }
    },
    async asyncFindTradeItemDesp (query, index) 
    {
        let product_id = this.sales_document.items[index].product_id
        let pv = { value: query, contact_id:this.sales_document.contact_id, date:"", product_id: product_id};
        axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.tradeitem_desp_list = response.data.data
            Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
          } 
          else 
          {
            this.tradeitem_desp_list = []
          }
        })
        .catch((error) => 
        {
          if (error.response) 
          {
            Vue.notify({
              group: "notify",
              type: "error",
              text: error.response.data.msg,
              max: 5,
              duration: 5000,
              speed: 300,
            });
          } 
          else 
          {
            console.log("Problem Querying Data", error);
          }
        });
    },
    async asyncFindVendor(query)
    {
      this.loadingCounter++
      let pv = { value: query };
      await axios.post(apiRoutes["VENDOR_LOOKUP"], pv, authHeader()).then((response) => {
          if (response.data.code == 1) {
            this.customers = response.data.data;
          } else {
            this.customers = [];
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          } else {
            console.log("Problem submitting New Post", error);
          }
        });
        this.loadingCounter--;
    },
    async asyncFindCustomer(query) 
    {
      this.loadingCounter++
      let payload = { value: query };
      await axios.post(apiRoutes["CUSTOMER_LOOKUP"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) {
          this.customers = response.data.data;
          if (this.customers.length == 1)
          {
            this.sales_document.customer_credit_term = this.customers[0].customer_credit_term;
            this.sales_document.customer_credit_limit = this.customers[0].customer_credit_limit;
            this.sales_document.customer_credit_limit_available = this.customers[0].customer_credit_limit_available;
            this.sales_document.customer_amount_overdue = this.customers[0].customer_amount_overdue
          }
        } else {
          this.customers = [];
        }
      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      this.loadingCounter--;
    },
  },
};
</script>
<style>
  th.VueTables__sortable {
      color:rgb(255,255,255);
  }
  td.VueTables__row  {
      color:black
  }
  .v-data-table /deep/ .sticky-header {
    position: sticky;
    top: var(--toolbarHeight);
  }
  
  .v-data-table /deep/ .v-data-table__wrapper {
    overflow: unset;
  }
</style>
<style scoped>
.marginCheck{
  margin-right:90px;
}
 .float-button2
  {

    position:fixed;
    width:60px;
    height:60px;
    bottom:40px;
    /* background-color:#0C9; */
    background-color:#2dce89;
    color:#FFF;
    border-radius:50px;
    text-align:center;
    box-shadow: 2px 2px 3px #999;
  }
/* .marginPlus{
  margin-right:220px;
} */
</style>